export type UserAccountLabel = 'general' | 'notifications' | 'change_password';
export type AdministrationCompanyTab = 'info' | 'notifications' | 'security' | 'subscription' | 'branding';
export type MailroomTab = 'info' | 'settings' | 'receive' | 'actions' | 'printing';

export type MailroomMailpieceCategory = 'requests' | 'search' | 'active/items';

export const inboxLabels = ['new', 'processing', 'processed', 'archive'] as const;
type InboxLabelTuple = typeof inboxLabels;
export type InboxMailpieceCategory = InboxLabelTuple[number];

function path(root: string, sublink: string) {
  return `${root}${sublink}`;
}

const ROOTS_KT_ADMIN = '/superadmin';

export const DEFAULT_REDIRECT_URL = {
  default: '/',
  mailroom: '/mailroom/dashboard',
  recipient: '/inbox/new',
  users: '/administration/users',
};

export const PATH_KT_ADMIN = {
  root: ROOTS_KT_ADMIN,
  onboarding: path(ROOTS_KT_ADMIN, '/onboarding'),
  createCompany: path(ROOTS_KT_ADMIN, '/create-company'),
};

export const userRoutes = {
  account: () => `/user/account`,
};

export const administrationRoutes = {
  accountSetup: '/administration/account-setup',
  // Parameter 'tab' must be optional to enable proper navigation menu highlight for child pages.
  company: (tab?: AdministrationCompanyTab) => `/administration/company?tab=${tab || 'info'}`,
  mailroom: (tab?: MailroomTab) => `/administration/mailroom?tab=${tab || 'info'}`,
  users: '/administration/users',
  createUser: '/administration/users/create',
  editUser: (id: string) => `/administration/users/edit/${id}`,
  upload: '/administration/users/upload',
  automations: '/administration/automations',
  automationCreate: '/administration/automations/create',
  automationEdit: (id: number) => `/administration/automations/edit/${id}`,
  automationsConflicts: '/administration/automations/conflicts',
  delivery: '/administration/delivery',
  routes: '/administration/delivery/routes',
  routesEdit: (id: number) => `/administration/delivery/routes/${id}`,
  routesNew: '/administration/delivery/routes/create',
  locations: '/administration/delivery/locations',
  locationEdit: (id: number) => `/administration/delivery/locations/${id}`,
  locationNew: '/administration/delivery/locations/create',
  notificationTemplates: '/administration/notifications/',
  notificationTemplatesEdit: (id: number, tab: string) => `/administration/notifications/${id}?tab=${tab}`,
  groups: '/administration/groups/',
  groupsNew: '/administration/groups/create',
  groupsEdit: (id: number) => `/administration/groups/${id}`,
};

export const mailroomRoutes = {
  root: '/mailroom/active',
  dashboard: '/mailroom/dashboard',
  receive: '/mailroom/receive',
  items: '/mailroom/active/items',
  storageGroups: '/mailroom/active/storage-groups',
  container: (id: number) => `/mailroom/active/storage-groups/${id}`,
  mailpiece: (mailroomMailpieceCategory: string, id: number) => `/mailroom/${mailroomMailpieceCategory}/${id}`,
  pendingRequest: '/mailroom/requests',
  search: '/mailroom/search',
};

export const inboxRoutes = {
  inbox: (label: InboxMailpieceCategory) => `/inbox${label ? '/' + label : ''}`,
  mailpiece: (inboxMailpieceCategory: string, id: number) => `/inbox/${inboxMailpieceCategory}/${id}`,
};

export const generalRoutes = {
  page404: '/404',
  pageErrorMFA: '/error-mfa',
};

export const identityServer = {
  manage: import.meta.env.VITE_APP_IDENTITY + '/Manage',
};
